import Keycloak from "keycloak-js";

/**
 * Create keycloak
 */
const kcInstance = new Keycloak({
  url: process.env.REACT_APP_KEYCLOAK_URL,
  realm: process.env.REACT_APP_KEYCLOAK_REALM,
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
});

export default kcInstance;
